<template>
  <div class="header">
    <div class="header-box centre">
      <div class="header-logo">
        <img src="../assets/img/index/logo.png" alt="">
      </div>
      <div class="header-menu">
        <ul class="menu-ul">
          <li
            v-for="item in itemList"
            :class="activeHeader(item)"
            @click="setLink(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="menu-tips">
        <!--          <button class="language">繁</button>-->
        <div v-if="getUserBool" class="login">
          <span @click="loginOut">退出</span>
        </div>
        <div v-else class="login">
          <span @click="loginBtn">登录</span> /
          <span @click="signBtn">注册</span>
        </div>
      </div>
    </div>
    <UserLogin ref="UserLogin" />
    <Sign ref="Sign" />
  </div>
</template>

<script>
import UserLogin from "./login/UserLogin.vue";
import Sign from './login/Sign.vue'
export default {
  data() {
    return {
      itemList: [
        { name: "首页", path: "/", permission: "首页" },
        { name: "在线书库", path: "/library", permission: "在线书库" },
        { name: "关于我们", path: "/about", permission: "关于我们" },
        { name: "读者中心", path: "/reader", permission: "读者中心" },
      ],
    };
  },
  computed:{
    getUserBool(){
      return this.$store.state.userInfo.userId && sessionStorage.getItem("portal_user_info");
    },
  },
  methods: {
    activeHeader(item) {
      return item.path == this.$route.path ? "active" : "";
    },
    setLink(item) {
      this.$router.push({ path: item.path });
    },
    loginBtn() {
      this.$refs.UserLogin.openDialog(false);
    },
    signBtn() {
      this.$refs.Sign.openDialog(false);
    },
    loginOut() {
      this.$store.commit("setUserInfo", {
        userId: "",
        userName: "",
      });
      sessionStorage.setItem("portal_user_info", "");
      this.$message("已退出登录")
    },
  },
  components: {
    UserLogin,
    Sign
  },
   created() {
      //设置临时调试端口
      this.$store.commit("setTypeId", window.location.port)
      //this.$store.commit("setTypeId", 9003)
    }
};
</script>

<style lang="less" scoped>
.header {
  width: 100%;
  height: 102px;
  background: #654719;
  color: #fff;
  .header-box {
    height: 102px;
    display: flex;
    margin: auto;
    align-items: center;
    .header-logo {
      font-size: 34px;
      letter-spacing: 2px;
      flex: 1;
      img {
        margin-top: 16px
      }
    }
    .header-menu {
      display: flex;
      font-size: 24px;
      letter-spacing: 1px;
      margin-left: 20px;
      .menu-ul {
        display: flex;
        flex: 1;
        li {
          cursor: pointer;
          font-weight: bold;
          margin-right: 30px;
        }
        li.active {
          border-bottom: 2px solid #fff;
          padding-bottom: 6px;
        }
      }
    }
  }
  .menu-tips {
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    letter-spacing: 2px;
    span:nth-child(2) {
      padding: 0 6px;
    }
  }
}
</style>
